import ResizeTextareaHook from "./resize-textarea-hook";
import ClearFlashHook from "./clear-flash-hook";
import ScrollTopHook from "./scroll-top-hook";
import ColorSchemeHook from "./color-scheme-hook";
import ClipboardHook from "./clipboard-hook";
import TippyHook from "./tippy-hook";
import LocalTimeHook from "./local-time-hook";
import ComboBoxHook from "./combo-box-hook";
import FloatingHook from "./floating-hook";
import "../lib/load-external-file";

export default {
  ResizeTextareaHook,
  ClearFlashHook,
  ScrollTopHook,
  ColorSchemeHook,
  ClipboardHook,
  LocalTimeHook,
  ComboBoxHook,
  FloatingHook,
};
